import React from 'react';
import LineChart from './LineChart';

/** One point per scored case, labelled 1…n. The timestamp is not the axis. */
export function sequencePoints(points) {
  return (points || []).map((point, index) => ({
    key: String(index + 1),
    label: String(index + 1),
    value: point && point.value != null ? point.value : null,
  }));
}

const SequenceChart = ({ points, ariaLabel, size = 'compact' }) => {
  const drawn = sequencePoints(points);
  if (!drawn.some((point) => point.value != null)) return null;
  return (
    <LineChart
      points={drawn}
      size={size}
      format={(value) => String(value)}
      ariaLabel={ariaLabel || `Scores out of 100: ${drawn.map((point) => point.value == null ? 'no score' : point.value).join(', ')}`}
    />
  );
};

export default SequenceChart;
